import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchLeadTimelineData } from "../../../redux/prospect-reducers/prospectSlice";
// import LeadJourneyJSON from "./lead-journey.json";
import PaginationBar from "../lms-v2/lms-customised-comps/PaginationBar";
import {
  formatDate,
  getIcon,
  groupEventsByDate,
  renderEventDetails,
} from "./LMSMocks";

const LeadTimeline = ({
  userInfoData,
  rowData,
  toggleExpand,
  expandedItems,
}) => {
  const dispatch = useDispatch();
  const { leadTimeline, leadTimelineLoading, leadTimelineError } = useSelector(
    (state) => state.prospects
  );

  const [isPage, setIsPage] = useState(0);
  const [pageLimit, setPageLimit] = useState(10);
  const iniFilters = {
    page: isPage + 1,
    limit: pageLimit || 10,
    lead_id: rowData?.mobile || "",
    // lead_id: rowData?.lead_id,
  };
  const [filters, setFilters] = useState(iniFilters);

  // const data = LeadJourneyJSON.data;
  const iniTimelineData = {
    data: [],
    pagination: [],
  };
  const [timelineData, setTimelineData] = useState(iniTimelineData);

  const groupedEvents = groupEventsByDate(timelineData.data);

  const getGymTimeline = async (filters) => {
    dispatch(
      fetchLeadTimelineData({
        filters: filters,
        token: userInfoData?.token,
      })
    );
  };

  useEffect(() => {
    if (filters.lead_id) {
      getGymTimeline(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (
      !leadTimelineLoading &&
      !leadTimelineError &&
      leadTimeline?.status &&
      leadTimeline?.data
    ) {
      setTimelineData((prev) => ({
        ...prev,
        data: leadTimeline.data,
        pagination: leadTimeline?.pagination,
      }));
    } else {
      setTimelineData(iniTimelineData);
    }
  }, [leadTimelineLoading, leadTimelineError, leadTimeline]);

  useEffect(() => {
    setFilters((prevs) => ({
      ...prevs,
      page: isPage + 1,
      limit: pageLimit,
    }));
  }, [isPage, pageLimit]);

  if (leadTimelineLoading) {
    return (
      <div className="lead-v2-cycle-loading">
        <div className="lead-v2-loading-spinner"></div>
        <p>Loading timeline...</p>
      </div>
    );
  }

  if (!timelineData.data || timelineData.data.length === 0) {
    return (
      <div className="lead-v2-cycle-empty">
        <p>No lead timeline found.</p>
      </div>
    );
  }

  console.log(
    "timelineData.pagination=> ",
    typeof Number(timelineData.pagination?.[0]?.pagination || 0)
  );

  return (
    <div className="lead-v2-timeline">
      {Object.keys(groupedEvents).length === 0 ? (
        <div className="lead-v2-timeline-empty">No lead timeline found</div>
      ) : (
        Object.keys(groupedEvents).map((groupTitle) => (
          <div key={groupTitle} className="lead-v2-timeline-group">
            <h5 className="lead-v2-timeline-group-title">{groupTitle}</h5>

            {groupedEvents[groupTitle].map((event, index) => {
              const { date, time } = formatDate(event.date_added);
              const eventId = `${groupTitle}-${index}`;
              const isExpanded = !!expandedItems[eventId];

              return (
                <div key={eventId} className="lead-v2-timeline-item">
                  <div className="lead-v2-timeline-left">
                    <div className="lead-v2-timeline-date">{date}</div>
                    <div className="lead-v2-timeline-time">{time}</div>
                  </div>

                  <div className="lead-v2-timeline-center">
                    <div className="lead-v2-timeline-icon-wrapper">
                      {getIcon(event.event_type)}
                    </div>
                    <div className="lead-v2-timeline-connector"></div>
                  </div>

                  <div className="lead-v2-timeline-right">
                    <div
                      className="lead-v2-event-summary"
                      onClick={() => toggleExpand(eventId)}
                    >
                      <span className="lead-v2-event-type">
                        {event.remarks}
                      </span>
                      <span className="lead-v2-event-creator">
                        Added by {event.created_by_name}
                      </span>
                    </div>
                    {isExpanded && renderEventDetails(event)}
                  </div>
                </div>
              );
            })}
          </div>
        ))
      )}

      {Number(timelineData.pagination?.[0]?.pagination || 0) > 10 && (
        <PaginationBar
          isPage={isPage}
          setIsPage={setIsPage}
          paginationArray={timelineData.pagination}
          pageLimit={pageLimit}
          setPageLimit={setPageLimit}
        />
      )}
    </div>
  );
};

export default LeadTimeline;
